export enum ReactionType {
    None = '',
    BrokenHeart = 'broken-heart',
    Celebration = 'celebration',
    Checkbox = 'checkbox',
    Comment = 'comment',
    Dislike = 'dislike',
    Five = 'five',
    Four = 'four',
    Heart = 'heart',
    Hmmm = 'hmmm',
    Idea = 'idea',
    Important = 'important',
    Like = 'like',
    Minus = 'minus',
    One = 'one',
    PlusOne = 'plus-one',
    Plus = 'plus',
    Question = 'question',
    Sad = 'sad',
    Scheduled = 'scheduled',
    Smile = 'smile',
    Three = 'three',
    Two = 'two',
    Unchecked = 'unchecked',
    Wait = 'wait',
}